import { Controller } from "@hotwired/stimulus"
import * as Toastr from 'toastr';
import 'toastr/build/toastr.css';

export default class extends Controller {
  static targets = [ "name", "description", "dueDate" ]

  focusDueDate() {
    if (this.dueDateTarget._flatpickr) {
      this.dueDateTarget._flatpickr.open();
    }
  }

  onPostSuccess(event) {
    if (event.detail.success) {
      $('#modal-new-task-window').modal('hide');
      Toastr.success('Task created!');
      this.nameTarget.value = "";
      this.dueDateTarget.value = "";
      // TODO: replace this reload with turbo frame to avoid refresh
      location.reload();
    }
  }
}
